import styled from 'styled-components'
import color from './colors'

const logoSize = 42

export default styled.div`
  height: 100%;
  
  a {
    color: ${color.mainColor}!important;
    &:hover {
      text-decoration: underline;
    }
  }

  .ant-layout-sider-children {
    border-right: 1px solid #eef0f4;
  }

  .ant-layout {
    min-height: 100%;
  }

  .ant-layout-header {
    .ant-dropdown-link {
      color: #fff!important;
      text-decoration: none;
    }

    .navigationMenu {
      float: right;
    }

    .trigger {
      color: #fff;
    }

    .navigationMenu {
      .role {
        font-weight: normal;
        font-size: 12px;
        font-style: italic; 
      }
    }
  }

  .ant-layout-sider {
    .ant-menu-inline {
      border-right:0;
    }

    .logo {
      position: relative;
      height: 64px;
      padding: 11px 8px 11px 68px;
  
      .logo-wrapper {
        position: absolute;
        margin-left: ${-logoSize-8}px;
        width: ${logoSize}px;
        height: ${logoSize}px;
        border-radius: 4px;
        overflow: hidden;
  
        img {
          width: 100%;
        }
      }
  
      .title {
        font-size: 1rem;
        font-weight: bold;
        height: 24px;
      }
  
      .detail {
        font-size: 0.8rem;
        height: 19px;
      }
  
      .title, .detail {
        white-space: nowrap; 
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .ant-layout-sider-collapsed {
    .ant-menu-vertical {
      border-right:1px solid #eef0f4;
    }

    .logo {
      .title, .detail {
        display: none;
      }

      .logo-wrapper {
        margin-left: -50px;
      }
    }
  }

  .pageHeader {
    background: #fff;
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #eef0f4;

    h1 {
      margin:0;
    }

    .bread-crum {
      padding-bottom: 0.6rem;
    }
  }

  .ant-card-body {
    form {
      .ant-row:nth-last-child(1) {
        margin-bottom: 0px;
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/style/common.style.js